export function waitForClick(event) {
    var currentTarget = event.currentTarget;
    var resolveClick = function resolveClick() {};
    var clickPromise = new Promise(function(resolve) {
        resolveClick = resolve;
    });
    var raceTimeout = new Promise(function(resolve) {
        setTimeout(resolve, 500);
    });
    currentTarget.addEventListener('click', resolveClick);
    return new Promise(function(resolve) {
        Promise.race([
            clickPromise,
            raceTimeout
        ]).then(function() {
            currentTarget.addEventListener('click', resolveClick);
            resolve();
        });
    });
}

//# sourceMappingURL=waitForClick.js.map